var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-geo-json',{ref:"geolayer",attrs:{"geojson":_vm.geojsonData.geojson,"options":_vm.geojsonOptions}}),_vm._t("default",null,{"currentItem":_vm.currentItem,"unit":_vm.value.metric,"min":_vm.min,"max":_vm.max})],2)}
var staticRenderFns = []

export { render, staticRenderFns }